/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_Digital_Product_PayloadInputs */

const en_doc_type_digital_product_payload = /** @type {(inputs: Doc_Type_Digital_Product_PayloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital Product Payload`)
};

const id_doc_type_digital_product_payload = /** @type {(inputs: Doc_Type_Digital_Product_PayloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isi Produk Digital`)
};

/** @type {(inputs: Doc_Type_Digital_Product_PayloadInputs) => LocalizedString} */
const es_doc_type_digital_product_payload = en_doc_type_digital_product_payload;

/** @type {(inputs: Doc_Type_Digital_Product_PayloadInputs) => LocalizedString} */
const fr_doc_type_digital_product_payload = en_doc_type_digital_product_payload;

/** @type {(inputs: Doc_Type_Digital_Product_PayloadInputs) => LocalizedString} */
const de_doc_type_digital_product_payload = en_doc_type_digital_product_payload;

/** @type {(inputs: Doc_Type_Digital_Product_PayloadInputs) => LocalizedString} */
const ja_doc_type_digital_product_payload = en_doc_type_digital_product_payload;

/** @type {(inputs: Doc_Type_Digital_Product_PayloadInputs) => LocalizedString} */
const zh_doc_type_digital_product_payload = en_doc_type_digital_product_payload;

/** @type {(inputs: Doc_Type_Digital_Product_PayloadInputs) => LocalizedString} */
const ar_doc_type_digital_product_payload = en_doc_type_digital_product_payload;

/** @type {(inputs: Doc_Type_Digital_Product_PayloadInputs) => LocalizedString} */
const it_doc_type_digital_product_payload = en_doc_type_digital_product_payload;

/** @type {(inputs: Doc_Type_Digital_Product_PayloadInputs) => LocalizedString} */
const ru_doc_type_digital_product_payload = en_doc_type_digital_product_payload;

/** @type {(inputs: Doc_Type_Digital_Product_PayloadInputs) => LocalizedString} */
const pt_doc_type_digital_product_payload = en_doc_type_digital_product_payload;

/** @type {(inputs: Doc_Type_Digital_Product_PayloadInputs) => LocalizedString} */
const ko_doc_type_digital_product_payload = en_doc_type_digital_product_payload;

/**
* | output |
* | --- |
* | "Digital Product Payload" |
*
* @param {Doc_Type_Digital_Product_PayloadInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_digital_product_payload = /** @type {((inputs?: Doc_Type_Digital_Product_PayloadInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_Digital_Product_PayloadInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_digital_product_payload(inputs)
	if (locale === "es") return es_doc_type_digital_product_payload(inputs)
	if (locale === "fr") return fr_doc_type_digital_product_payload(inputs)
	if (locale === "de") return de_doc_type_digital_product_payload(inputs)
	if (locale === "ja") return ja_doc_type_digital_product_payload(inputs)
	if (locale === "zh") return zh_doc_type_digital_product_payload(inputs)
	if (locale === "ar") return ar_doc_type_digital_product_payload(inputs)
	if (locale === "id") return id_doc_type_digital_product_payload(inputs)
	if (locale === "it") return it_doc_type_digital_product_payload(inputs)
	if (locale === "ru") return ru_doc_type_digital_product_payload(inputs)
	if (locale === "pt") return pt_doc_type_digital_product_payload(inputs)
	return ko_doc_type_digital_product_payload(inputs)
});